import './public-path';
import React from 'react';
import * as smoothscroll from 'smoothscroll-polyfill';
import { message } from 'antd';
import { setupTracer } from './tracer';
import * as sentry from './setup-sentry';
import App from './routers';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { setGlobalRouter } from './utils/globalRouter';
import { setAutoFreeze } from 'immer';
import ErrorBoundary from '@src/components/common/ErrorBoundary';

// Adding trace to launch file(index.tsx) makes it available in the application for use
if (process.env.NODE_ENV !== 'development') {
  setupTracer();
}

// Disable immer auto freeze to avoid exceptions
setAutoFreeze(false);

smoothscroll.polyfill();
let root;

const render = (props) => {
  sentry.start();
  const { container = document.body } = props;
  const mountedNode = container.querySelector('#app');
  const router = createBrowserRouter([{ path: '/*', element: <App container={container} /> }]);
  setGlobalRouter(router);
  root = createRoot(mountedNode);
  root.render(
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>,
  );
};

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  // do nothing
}

export async function mount(props) {
  if (!window.conviva || !window.conviva.microProps) {
    Object.defineProperty(window.conviva, 'microProps', {
      value: props,
      writable: false,
    });
  }
  render(props);
}

export async function unmount() {
  // Destroy all message components to avoid unnecessary message tips inner async function
  message.destroy();
  if (root) {
    root.unmount();
  }

  sentry.stop();
}
